import React from 'react';
import { Container, Typography, Link, Stack, Box, IconButton, Tooltip, Divider, Grid } from '@mui/material';
import { Facebook, Instagram, WhatsApp, Phone, Email } from '@mui/icons-material';

const Footer = () => {
    const currentYear = new Date().getFullYear();
    const phoneNumber = '918006854360';
    const email = 'info@bisauli.com';

    const handleWhatsApp = () => {
        const message = 'Hello! I would like to inquire about your services.';
        window.open(`https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`, '_blank');
    };

    const handleCall = () => {
        window.location.href = `tel:+${phoneNumber}`;
    };

    const handleEmail = () => {
        window.location.href = `mailto:${email}`;
    };

    const handleSocialLink = (url) => {
        window.open(url, '_blank');
    };

    return (
        <Box component="footer" sx={{ 
            bgcolor: '#2d3748', 
            color: '#fff',
            py: { xs: 4, md: 6 }, 
            mt: { xs: 6, md: 8 }
        }}>
            <Container maxWidth="lg">
                <Grid container spacing={{ xs: 3, md: 4 }} sx={{ mb: 4 }}>
                    {/* Company Info */}
                    <Grid item xs={12} sm={6} md={3}>
                        <Typography variant="h6" sx={{ fontWeight: 800, mb: 2, color: '#667eea' }}>
                            🏠 अपना बिसौली
                        </Typography>
                        <Typography variant="body2" sx={{ color: '#cbd5e0', mb: 2, lineHeight: 1.6 }}>
                        में स्थानीय प्रॉपर्टी और प्रोफेशनल सेवाओं के लिए आपका भरोसेमंद प्लेटफॉर्म
                        </Typography>
                    </Grid>

                    {/* Quick Links */}
                    <Grid item xs={12} sm={6} md={3}>
                        <Typography variant="h6" sx={{ fontWeight: 700, mb: 2 }}>Quick Links</Typography>
                        <Stack spacing={1}>
                            <Link href="/" color="inherit" sx={{ 
                                textDecoration: 'none', 
                                color: '#cbd5e0',
                                transition: 'all 0.3s ease',
                                '&:hover': { color: '#667eea', pl: 0.5 }
                            }}>
                                🏠 होम
                            </Link>
                            <Link href="/all-properties" color="inherit" sx={{ 
                                textDecoration: 'none', 
                                color: '#cbd5e0',
                                transition: 'all 0.3s ease',
                                '&:hover': { color: '#667eea', pl: 0.5 }
                            }}>
                                🏘️ Properties
                            </Link>
                            <Link href="/all-services" color="inherit" sx={{ 
                                textDecoration: 'none', 
                                color: '#cbd5e0',
                                transition: 'all 0.3s ease',
                                '&:hover': { color: '#667eea', pl: 0.5 }
                            }}>
                                🔧 Services
                            </Link>
                            <Link href="/submit" color="inherit" sx={{ 
                                textDecoration: 'none', 
                                color: '#cbd5e0',
                                transition: 'all 0.3s ease',
                                '&:hover': { color: '#667eea', pl: 0.5 }
                            }}>
                                ➕ Submit Listing
                            </Link>
                        </Stack>
                    </Grid>

                    {/* Policies */}
                    <Grid item xs={12} sm={6} md={3}>
                        <Typography variant="h6" sx={{ fontWeight: 700, mb: 2 }}>Policies</Typography>
                        <Stack spacing={1}>
                            <Link href="/privacy-policy" color="inherit" sx={{ 
                                textDecoration: 'none', 
                                color: '#cbd5e0',
                                transition: 'all 0.3s ease',
                                '&:hover': { color: '#667eea', pl: 0.5 }
                            }}>
                                Privacy Policy
                            </Link>
                            <Link href="/terms-of-service" color="inherit" sx={{ 
                                textDecoration: 'none', 
                                color: '#cbd5e0',
                                transition: 'all 0.3s ease',
                                '&:hover': { color: '#667eea', pl: 0.5 }
                            }}>
                                Terms of Service
                            </Link>
                            <Link href="/about" color="inherit" sx={{ 
                                textDecoration: 'none', 
                                color: '#cbd5e0',
                                transition: 'all 0.3s ease',
                                '&:hover': { color: '#667eea', pl: 0.5 }
                            }}>
                                About Us
                            </Link>
                            <Link href="/contact" color="inherit" sx={{ 
                                textDecoration: 'none', 
                                color: '#cbd5e0',
                                transition: 'all 0.3s ease',
                                '&:hover': { color: '#667eea', pl: 0.5 }
                            }}>
                                Contact Us
                            </Link>
                        </Stack>
                    </Grid>

                    {/* Get in Touch - WITH CONTACT INFO */}
                    <Grid item xs={12} sm={6} md={3}>
                        <Typography variant="h6" sx={{ fontWeight: 700, mb: 2 }}>📞 Get in Touch</Typography>
                        <Stack spacing={2}>
                            {/* Contact Information */}
                            <Box sx={{ mb: 2 }}>
                                <Typography variant="caption" sx={{ color: '#a0aec0', display: 'block', mb: 0.5 }}>
                                    Phone:
                                </Typography>
                                <Link 
                                    href={`tel:+${phoneNumber}`}
                                    sx={{ 
                                        textDecoration: 'none', 
                                        color: '#667eea',
                                        fontWeight: 600,
                                        transition: 'all 0.3s ease',
                                        '&:hover': { color: '#fff' }
                                    }}
                                >
                                    +91 {phoneNumber.slice(2, 5)} {phoneNumber.slice(5, 8)} {phoneNumber.slice(8)}
                                </Link>
                                
                                <Typography variant="caption" sx={{ color: '#a0aec0', display: 'block', mt: 1.5, mb: 0.5 }}>
                                    Email:
                                </Typography>
                                <Link 
                                    href={`mailto:${email}`}
                                    sx={{ 
                                        textDecoration: 'none', 
                                        color: '#667eea',
                                        fontWeight: 600,
                                        transition: 'all 0.3s ease',
                                        wordBreak: 'break-all',
                                        '&:hover': { color: '#fff' }
                                    }}
                                >
                                    {email}
                                </Link>
                            </Box>

                            {/* Action Buttons */}
                            <Box sx={{ display: 'flex', gap: 1.5, flexWrap: 'wrap' }}>
                                {/* WhatsApp */}
                                <Tooltip title="WhatsApp">
                                    <IconButton
                                        onClick={handleWhatsApp}
                                        size="small"
                                        sx={{
                                            bgcolor: '#25D366',
                                            color: '#fff',
                                            transition: 'all 0.3s ease',
                                            '&:hover': {
                                                bgcolor: '#1fbb4f',
                                                transform: 'translateY(-4px)',
                                                boxShadow: '0 4px 12px rgba(37, 211, 102, 0.4)'
                                            }
                                        }}
                                    >
                                        <WhatsApp sx={{ fontSize: '1.2rem' }} />
                                    </IconButton>
                                </Tooltip>

                                {/* Phone */}
                                <Tooltip title="Call Us">
                                    <IconButton
                                        onClick={handleCall}
                                        size="small"
                                        sx={{
                                            bgcolor: '#667eea',
                                            color: '#fff',
                                            transition: 'all 0.3s ease',
                                            '&:hover': {
                                                bgcolor: '#5568d3',
                                                transform: 'translateY(-4px)',
                                                boxShadow: '0 4px 12px rgba(102, 126, 234, 0.4)'
                                            }
                                        }}
                                    >
                                        <Phone sx={{ fontSize: '1.2rem' }} />
                                    </IconButton>
                                </Tooltip>

                                {/* Email */}
                                <Tooltip title="Send Email">
                                    <IconButton
                                        onClick={handleEmail}
                                        size="small"
                                        sx={{
                                            bgcolor: '#f6ad55',
                                            color: '#fff',
                                            transition: 'all 0.3s ease',
                                            '&:hover': {
                                                bgcolor: '#ed8936',
                                                transform: 'translateY(-4px)',
                                                boxShadow: '0 4px 12px rgba(246, 173, 85, 0.4)'
                                            }
                                        }}
                                    >
                                        <Email sx={{ fontSize: '1.2rem' }} />
                                    </IconButton>
                                </Tooltip>
                            </Box>
                        </Stack>
                    </Grid>
                </Grid>

                {/* Divider */}
                <Divider sx={{ bgcolor: '#4a5568', my: 3 }} />

                {/* Social Media & Copyright */}
                <Stack spacing={2}>
                    {/* Social Links */}
                    <Box sx={{ display: 'flex', justifyContent: 'center', gap: 1 }}>
                        <Tooltip title="Facebook">
                            <IconButton
                                onClick={() => handleSocialLink('https://facebook.com/mybisauli')}
                                size="small"
                                sx={{
                                    color: '#1877F2',
                                    transition: 'all 0.3s ease',
                                    '&:hover': {
                                        transform: 'scale(1.2)',
                                        bgcolor: 'rgba(24, 119, 242, 0.1)'
                                    }
                                }}
                            >
                                <Facebook />
                            </IconButton>
                        </Tooltip>


                        <Tooltip title="Instagram">
                            <IconButton
                                onClick={() => handleSocialLink('https://www.instagram.com/mybisauli')}
                                size="small"
                                sx={{
                                    background: 'linear-gradient(45deg, #FD1D1D 0%, #833AB4 50%, #FD1D1D 100%)',
                                    color: '#fff',
                                    transition: 'all 0.3s ease',
                                    '&:hover': {
                                        transform: 'scale(1.2)',
                                        boxShadow: '0 4px 12px rgba(253, 29, 29, 0.4)'
                                    }
                                }}
                            >
                                <Instagram />
                            </IconButton>
                        </Tooltip>

                    </Box>

                    {/* Copyright */}
                    <Box sx={{ textAlign: 'center' }}>
                        <Typography variant="body2" sx={{ color: '#cbd5e0', mb: 1 }}>
                            © {currentYear} Apna अपना बिसौली - Local Properties & Services. All rights reserved.
                        </Typography>
                        <Typography variant="caption" sx={{ color: '#a0aec0', fontSize: { xs: '0.7rem', sm: '0.8rem' } }}>
                            Made with ❤️ for the अपना बिसौली Community
                        </Typography>
                    </Box>
                </Stack>
            </Container>
        </Box>
    );
};

export default Footer;